import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enTranslation from "@assets/locales/en.json";
import koTranslation from "@assets/locales/ko.json";

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: "ko",
    fallbackLng: "ko",
    interpolation: { escapeValue: false }, // not needed for react as it escapes by default
    resources: {
      en: { translation: enTranslation },
      ko: { translation: koTranslation },
    },
  });

export default i18n;
